import React, { useState, useEffect } from 'react';
import { Link, Redirect, useParams } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'
import LoggedOutHeader from '../../components/header/LoggedOutHeader';
import SetTitle from '../../components/shared/SetTitle';
import BigLogo from '../../components/header/BigLogo';

import { getStripe } from '../../utilities/Stripe';

import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';

const SignUpStart = () => {
  const { coupon } = useParams();

  const [clientSecret, setClientSecret] = useState(null);
  const [clientSecretLoaded, setClientSecretLoaded] = useState(false);
  const [stripePromise, setStripePromise] = useState(null);
  const [error, setError] = useState(null);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    getStripe().then(setStripePromise);
  }, []);

  useEffect(() => {
    let params = ""

    if (coupon) {
      params = `?coupon=${coupon}`
    }
    // Fetch the client_secret key from Stripe
    request('POST', `/v1/a/sign_up${params}`, null, () => { setUnauthorized(true) })
      .then(data => {
        setClientSecret(data.client_secret)
        setClientSecretLoaded(true)
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        setError(error)
      })
  }, [coupon]);

  if (unauthorized) {
    return <Redirect to="/login"/>
  }

  if (error) {
    return <div>{error.message}</div>;
  }

  if (clientSecretLoaded === false || stripePromise === null) {
    return <p>Loading ...</p>;
  }

  const options = {
    clientSecret: clientSecret
  }

  if (clientSecretLoaded && stripePromise) {
    return (
      <div className="login-page">
        <SetTitle title={"Sign Up"} />
        <LoggedOutHeader />

        <div className="center-container">
            <p className="welcome-to">Welcome to...</p>

            <BigLogo />

            <p>
              Please enter your card details below to set up a recurring monthly subscription. <br />
              This will create an Organisation and Location for you to start using immediately. <br />
              If you need multiple Locations, you can change the quantity now, or upgrade later.
            </p>
            <p>Running into trouble, or wondering which tablet to aquire? Consult our <Link to={{ pathname: "https://www.dreception.com/sign-up-info"}} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFilePdf} /> Sign Up Info Sheet</Link></p>

            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
        </div>
      </div>
    )
  }
};

export default SignUpStart;
